import React, { createContext, useContext, useEffect, useState } from "react";

const CompareContext = createContext(null);
const KEY = "shams_compare_v1";
const MAX = 4;

export function CompareProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(ids));
  }, [ids]);

  const has = (id) => ids.includes(id);

  const toggle = (id) => {
    setIds((prev) => {
      if (prev.includes(id)) return prev.filter((p) => p !== id);
      if (prev.length >= MAX) return prev;
      return [...prev, id];
    });
  };

  const clear = () => setIds([]);

  return (
    <CompareContext.Provider value={{ ids, has, toggle, clear, count: ids.length, max: MAX }}>
      {children}
    </CompareContext.Provider>
  );
}

export const useCompare = () => useContext(CompareContext);
